import { Vue } from 'vue-property-decorator';
import * as date_fns_format from 'date-fns/format';
Vue.filter('date', function (value, format) {
    if (format === void 0) { format = 'MM/DD/YYYY hh:mm A'; }
    if (value) {
        return date_fns_format(value, format);
    }
});
